const DEFAULT_SITE_URL = "https://www.city-scope.co.uk";

function normalizeSiteUrl(value) {
  const trimmed = String(value || "").trim().replace(/\/+$/, "");
  if (!trimmed) return DEFAULT_SITE_URL;

  if (/^https?:\/\/city-scope\.co\.uk$/i.test(trimmed)) {
    return DEFAULT_SITE_URL;
  }

  return trimmed;
}

export const SITE_URL = normalizeSiteUrl(
  process.env.NEXT_PUBLIC_SITE_URL || process.env.SITE_URL || DEFAULT_SITE_URL
);

export function toAbsoluteSiteUrl(pathOrUrl) {
  const value = String(pathOrUrl || "").trim();
  if (!value) return SITE_URL;
  if (/^https?:\/\//i.test(value)) return value;

  const normalizedPath = value.startsWith("/") ? value : `/${value}`;
  return `${SITE_URL}${normalizedPath}`;
}
